<template>
  <div :class="$style.field">
    <label :for="id">
      {{ entity.label }}
      <i v-if="required">*</i>
    </label>
    <input
      type="text"
      :id="id"
      :readonly="readonly"
      v-model="value"
      :placeholder="entity.description"
      :name="name"
      :required="required"
      :maxlength="maxlength"
      :autocomplete="name"
    />
    <p v-show="error && showError">{{ error }}</p>
  </div>
</template>

<script>
import Field from "./field";

export default {
  mixins: [Field],
};
</script>

<style module lang="less" src="./field.less"></style>



// WEBPACK FOOTER //
// text-field.vue?f7cc2868